import React, {
  forwardRef,
  ForwardRefRenderFunction,
  useEffect,
  useState,
  useRef,
  useMemo,
} from "react";
// 注意 FormInstance 这里的别引入错了，要用当前项目里的
import { FormInstance } from "../../../../hooks/createForm";
import { User } from "authing-js-sdk";
import styles from "./styles.module.less";
import { Spin } from "antd";
import classnames from "classnames";
import { getUserRegisterParams } from "../../../../utils";
import { QrCodeAuthenticationClient } from "authing-js-sdk/build/main/lib/authentication/QrCodeAuthenticationClient";

// 表单参数

export type QrCodeType =
  | "wechat-miniprogram-qrcode"
  | "app-qrcode"
  | "wechatmp-qrcode";
export interface QrCodeFormProps extends React.HTMLAttributes<HTMLDivElement> {
  onSuccess?: (user: User) => void;
  onFail?: (error: any) => void;
  type: QrCodeType;
  idpId?: string;
  setTimer?: Function;
}

const InternalQrCodeForm: ForwardRefRenderFunction<
  FormInstance,
  QrCodeFormProps
> = ({ onSuccess, onFail, type, idpId, setTimer }, ref) => {
  const timerRef = useRef<any>();
  const [startedKey, setStartedKey] = useState("");
  const containerId = useMemo(() => {
    if (idpId) {
      return String(type) + ":" + String(idpId);
    } else {
      return String(type);
    }
  }, [type, idpId]);
  const authenticationClient = window.__authing__;
  const typeMapConfig: Record<QrCodeType, QrCodeAuthenticationClient> = {
    "wechat-miniprogram-qrcode": authenticationClient.wxqrcode,
    "app-qrcode": authenticationClient.qrcode,
    "wechatmp-qrcode": authenticationClient.wechatmpqrcode,
  };

  const client = typeMapConfig[type];
  useEffect(() => {
    if (!containerId) return;
    if (startedKey === containerId) return;
    setStartedKey(containerId);

    const onScanningSuccess = async (userInfo: any, ticket: string) => {
      const { token } = userInfo;
      if (!token) {
        // 轮询接口不会返回完整用户信息，需要使用 ticket 换取
        userInfo = await client.exchangeUserInfo(ticket);
      }
      onSuccess && onSuccess(userInfo);
    };
    client.startScanning(containerId, {
      // onCodeShow:
      onSuccess: onScanningSuccess,
      onError: (message) => onFail && onFail(`${message}`),
      customData: getUserRegisterParams(),
      onStart(timer) {
        if (setTimer) {
          setTimer(timer);
        }
        timerRef.current = timer;
      },
      extIdpConnId: idpId,
    });

    return () => {
      clearInterval(timerRef.current);
    };
  }, [
    onFail,
    onSuccess,
    startedKey,
    setStartedKey,
    client,
    containerId,
    idpId,
    setTimer,
  ]);

  return (
    <div
      className={classnames(styles.container, "authing-qrcode-login-container")}
    >
      <div className={styles.loading}>
        <Spin size="large" />
      </div>
      <div id={containerId}></div>
    </div>
  );
};

export const QrCodeForm = forwardRef<FormInstance, QrCodeFormProps>(
  InternalQrCodeForm
);
